export default "__VITE_ASSET__BkzvLIXz__"